import { env } from "../../env/env";
import { MenuFolderDto } from "../../generated/dashboard-client";
import { DesignProduct } from "../../util/Products";
import "./CreateDesignModal.scss";

export interface CreateDesignMenuContentProps {
	products: DesignProduct[];
	activeFolder: MenuFolderDto | null;
}

export default function CreateDesignMenuContent({products, activeFolder} : CreateDesignMenuContentProps) {
	function startProduct(productKey: string) {
		let href = `${env.timberContextPath}/design?size=${productKey}`;
		if (activeFolder?.id!) {
			href += `&folderId=${activeFolder?.id!}`;
		}
		window.location.href = href;
	}

	return (<div className={"create-design-menu-content modal-body"}>
		<ul>
			{products.map((product) => {
				return (
				<li onClick={() => startProduct(product.key)}>
					{product.name}
				</li>
				)})}
		</ul>
	</div>)
}